import React from 'react';
import { createCommand, Option } from '@commander-js/extra-typings';
import type { CommandServices } from '@wix/cli-command-contract';

export const login = (services: CommandServices) => {
  return createCommand('login')
    .description('Log in to your Wix account')
    .option(
      '--api-key <token>',
      'Authenticate using an API key for automations and CI environments'
    )
    .addOption(
      new Option(
        '--refresh-token <token>',
        'Authenticate using an refresh token for automations and CI environments'
      )
        .hideHelp()
        .conflicts('apiKey')
    )
    .action(async (options, command) => {
      const { apiKey, refreshToken } = options;
      const { runCommand, renderCommand } = await import('./render-command.js');

      if (services.loginMode === 'agent') {
        await runCommand(command, services, async () => {
          const { nonInteractiveLogin } = await import(
            './non-interactive-login.js'
          );

          await nonInteractiveLogin({
            biLogger: services.biLogger,
          });
        });

        return;
      }

      const { getUserInfo } = await import('@wix/cli-auth');
      const { LoginCommand } = await import(
        '../components/LoginCommand/index.js'
      );

      const userInfo = await getUserInfo();

      await renderCommand(
        command,
        services,
        <LoginCommand
          apiKeyToken={apiKey}
          userInfo={userInfo}
          refreshToken={refreshToken}
        />
      );
    });
};
